//import data from '../data';
import { useContext, useEffect, useReducer, useState } from 'react';
import api, { ADMIN_URL } from '../api';
import logger from 'use-reducer-logger';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/esm/Col';
import Product from '../components/Product';
import { Helmet } from 'react-helmet-async';
import LoadingBox from '../components/LoadingBox';
import MessageBox from '../components/MeaasgeBox';
import CardHeader from '../components/CardHeadder';
import Container from 'react-bootstrap/Container';
import { NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Store } from '../Store';
import { useNavigate } from 'react-router-dom';

const reducer = (state, action) => {
  switch (action.type) {
    case 'FETCH_REQUEST':
      return { ...state, loading: true };
    case 'FETCH_SUCCESS':
      return { ...state, products: action.payload, loading: false };
    case 'FETCH_FAIL':
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

function HomeScreen() {
  const [{ loading, error, products }, dispatch] = useReducer(logger(reducer), {
    products: [],
    loading: true,
    error: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      dispatch({ type: 'FETCH_REQUEST' });
      try {
        const result = await api.get('/api/products');
        dispatch({ type: 'FETCH_SUCCESS', payload: result.data });
      } catch (err) {
        dispatch({ type: 'FETCH_FAIL', payload: err.message });
      }
    };
    fetchData();
  }, []);

  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { userInfo } = state;

  const navigate = useNavigate();

  const signoutHandler = () => {
    ctxDispatch({ type: 'USER_SIGNOUT' });
    localStorage.removeItem('userInfo');
    localStorage.removeItem('shippingAddress');
    localStorage.removeItem('paymentMethod');
    navigate('/signin');
  };

  return (
    <div>
      <CardHeader />
      <Container fluid="md" className="mt-2 py-5">
        <div>
          <Helmet>
            <title>Products</title>
          </Helmet>
          <Row className="align-items-center d-flex justify-content-between flex-wrap mb-3">
            <Col xs="auto">
              <h1 style={{ fontSize: '2rem', marginBottom: 0 }}>
                Feature Products
              </h1>
            </Col>

            <Col xs="auto">
              <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                {userInfo ? (
                  <NavDropdown
                    title={
                      <span
                        style={{ backgroundColor: '#801001' }}
                        className="px-3 py-2 text-white rounded-pill shadow-sm"
                      >
                        {userInfo.name}
                      </span>
                    }
                    id="collasible-nav-dropdown"
                  >
                    <NavDropdown.Item as={Link} to="/profile">
                      <span className="text-gray">User Profile</span>
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <Link
                      className="dropdown-item"
                      to="#signout"
                      onClick={signoutHandler}
                    >
                      <span className="text-gray">Signout</span>
                    </Link>
                  </NavDropdown>
                ) : (
                  <a
                    href={ADMIN_URL}
                    className="nav-link text-white px-3 py-2 rounded-pill shadow-sm"
                    style={{ backgroundColor: '#801001' }}
                  >
                    Signin
                  </a>
                )}

                {userInfo && userInfo.isAdmin && (
                  <NavDropdown
                    title={
                      <span
                        style={{ backgroundColor: '#801001' }}
                        className="px-3 py-2 text-white rounded-pill shadow-sm"
                      >
                        Admin
                      </span>
                    }
                    id="admin-nav-dropdown"
                  >
                    <NavDropdown.Item as={Link} to="/admin/products">
                      <span className="text-gray">Products</span>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin/orders">
                      <span className="text-gray">Orders</span>
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/admin/fabrics">
                      <span className="text-gray">Fabrics</span>
                    </NavDropdown.Item>
                  </NavDropdown>
                )}
              </div>
            </Col>
          </Row>

          <br />
          <div className="products">
            {loading ? (
              <LoadingBox />
            ) : error ? (
              <MessageBox variant="danger">{error}</MessageBox>
            ) : (
              <Row>
                {products.map((product) => (
                  <Col key={product.slug} sm={6} md={4} lg={3} className="mb-3">
                    <Product product={product}></Product>
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
}

export default HomeScreen;
